let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("fDVhN")]).then(() => parcelRequire('8be30'));